<template>
  <v-container fluid>
    <material-card v-if="endPoints.length" icon="mdi-clipboard-text" inline
      title="System End Point">
      <v-card-text class="pt-0 pr-1"
        :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp}">
        <v-text-field
          :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp}"
          v-model="search" append-icon="mdi-magnify" class="ml-auto mb-2" label="Search"
          hide-details single-line style="max-width:350px;" />
        <router-link :to="{name: 'SystemEndPoints'}"
          :class="{'d-flex justify-start':$vuetify.breakpoint.xs}">
          <v-btn elevation="1" :class="{ 'mt-2': $vuetify.breakpoint.xs}" color="accent"
            >
            <v-icon left>mdi-plus</v-icon>
            Add
          </v-btn>
        </router-link>
      </v-card-text>

      <v-divider class=" my-0 " />
      <v-data-table :footer-props="{
        'items-per-page-options': [5 ,10, 20, 40]
        }" :items-per-page="10" :headers="headers" :items="endPoints" :search.sync="search">
          <template v-slot:top>
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="headline">Are you sure you want to delete this item?
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="lightblue" text @click="closeDelete">Cancel
                  </v-btn>
                  <v-btn color="lightblue" text @click="deleteItemConfirm">OK
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
          <template v-slot:item.method="{item}">
            <div :class="getColor(item.method)">
              {{ item.method }}
            </div>
          </template>
          <template v-slot:item.actions="{item}">
            <router-link :to="{name: 'SystemEndPointsEdit', params: {endpointID: item.id}}">

              <v-btn
                class="px-2 ml-1 white--text ma-1"
                color="success"
                min-width="0"
                small
              >
                <v-icon small >
                mdi-pencil</v-icon>
              </v-btn>
            </router-link>
              <v-btn
                @click="deleteItem(item)" v-if="!item.deletedAt"
                class="px-2 ml-1 white--text ma-1"
                color="error"
                min-width="0"
                small
              >
                <v-icon small >
                mdi-delete</v-icon>
              </v-btn>
          </template>
          <template v-slot:no-data>
          <v-btn class="px-2 ml-1 white--text ma-1" color="error" min-width="0" small
            @click="restoreEndpoint(item.id)" v-if="item.deletedAt"> Reset</v-btn>

          </template>
        </v-data-table>
</material-card>
<material-card v-if="!endPoints.length">
          <v-data-table :headers="headers">
          <template v-slot:no-data >
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
         </template>
      </v-data-table>
</material-card>

  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import _sortBy from 'lodash/sortBy'
export default {
  components: { MaterialCard },
  name: 'SystemEndpointList',

  data () {
    return {
      enablePagination: false,
      endPoints: [],
      loadingComponent: null,
      myloadingvariable: false,
      dialog: false,
      dialogDelete: false,
      search: '',
      headers: [
        { text: 'Name', sortable: true, value: 'name' },
        { text: 'Method', value: 'method', align: 'center', sortable: false },
        { text: 'Description', value: 'description', sortable: false },
        { text: 'Module', value: 'module' },
        { text: 'Action', value: 'actions', align: 'center', sortable: false } ]
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    }
  },

  created () {
    this.getEndpoints()
  },
  methods: {

    getEndpoints: function () {
      this.loadingComponent = this.$buefy.loading.open()
      http
        .get(`${CONSTANTS.API_URL}/api/systemendpoints`)
        .then((endPoints) => {
          this.endPoints = _sortBy(endPoints.data, ['module'])
          this.loadingComponent.close()
        })
        .catch((e) => {
          this.loadingComponent.close()
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          this.enableUniformModal = false
          console.log('error in fetching franchisee : ', errorMessage)
          return this.$buefy.dialog.alert({
            type: 'is-danger',
            message: errorMessage,
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        })
    },
    deleteEndpoint: function (endPointID) {
      this.$dialog.confirm({
        title: 'Deactivate System Endpoint?',
        message: 'Are you sure you want to <b>deactivate</b> this Endpoint?',
        confirmText: 'Yes',
        cancelText: 'No',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.loadingComponent = this.$buefy.loading.open()

          return http
            .del(`${CONSTANTS.API_URL}/api/systemendpoint/${endPointID}`)
            .then(() => {
              this.getEndpoints()
              this.loadingComponent.close()

              return this.$buefy.dialog.alert({
                type: 'is-success',
                message: 'Endpoint Deactivated successfully.',
                hasIcon: true,
                animation: 'zoom-out',
                size: 'is-medium',

                icon: ' mdi-exclamation',
                iconPack: 'mdi',
                ariaRole: 'alertdialog',
                ariaModal: true
              })
            })
            .catch((httpException) => {
              this.loadingComponent.close()

              console.warn('Error while deleting Endpoint', httpException.message)
              return this.$buefy.dialog.alert({
                type: 'is-danger',
                message: 'Error while Deleting Endpoint',
                hasIcon: true,
                animation: 'zoom-out',
                size: 'is-medium',

                icon: ' mdi-exclamation',
                iconPack: 'mdi',
                ariaRole: 'alertdialog',
                ariaModal: true
              })
            })
        }
      })
    },
    restoreEndpoint: function (endPointID) {
      this.$dialog.confirm({
        title: 'Restore System Endpoint?',
        message: 'Are you sure you want to <b>restore</b> this Endpoint?',
        confirmText: 'Yes',
        cancelText: 'No',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.loadingComponent = this.$buefy.loading.open()

          return http
            .put(`${CONSTANTS.API_URL}/api/systemendpoint/${endPointID}/restore`)
            .then(() => {
              this.getEndpoints()
              this.loadingComponent.close()

              return this.$buefy.dialog.alert({
                type: 'is-success',
                message: 'Endpoint restored successfully.',
                hasIcon: true,
                animation: 'zoom-out',
                size: 'is-medium',

                icon: ' mdi-exclamation',
                iconPack: 'mdi',
                ariaRole: 'alertdialog',
                ariaModal: true
              })
            })
            .catch((httpException) => {
              this.loadingComponent.close()

              console.warn('Error while restoring Endpoint', httpException.message)
              return this.$buefy.dialog.alert({
                type: 'is-danger',
                message: httpException.message,
                hasIcon: true,
                animation: 'zoom-out',
                size: 'is-medium',

                icon: ' mdi-exclamation',
                iconPack: 'mdi',
                ariaRole: 'alertdialog',
                ariaModal: true
              })
            })
        }
      })
    },
    getColor (method) {
      if (method === 'DELETE') return 'v-accent font-weight-bold'
      else if (method === 'POST') return 'v-pink font-weight-bold'
      else if (method === 'PUT') return 'v-warning font-weight-bold'
      else return 'v-green font-weight-bold'
    },
    deleteItem (item) {
      this.editedIndex = this.endPoints.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },
    deleteItemConfirm () {
      this.endPoints.splice(this.editedIndex, 1)
      this.closeDelete()
    },
    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    }
  }
}
</script>
